import * as React from "react";
import { TalentpairUser } from "@talentpair/entities/user";
import { Box, Typography, UserAvatar, Badge } from "@talentpair/quantic";

function PlaceholderBox({
  text,
  onSubmit,
  ...props
}: {
  text: string;
  onSubmit: (text: string) => unknown;
}): React.ReactElement {
  return (
    <Box
      variant="column"
      layout="center-start"
      space={3}
      className="br3 lt-grey-border hover-bg-grey-100 p3"
      background="grey.50"
      style={{ maxWidth: 375, cursor: "pointer" }}
      onClick={() => onSubmit(text)}
      {...props}
    >
      <Typography variant="body1" align="center">
        “{text}”
      </Typography>
    </Box>
  );
}

export function EmptyChatPlaceholder({
  desktop,
  onSubmit,
}: {
  desktop: boolean;
  onSubmit: (text: string) => unknown;
}): React.ReactElement {
  return (
    <Box
      variant="column"
      layout="center-center"
      space={5}
      className={`p3 max-width-1 mx-auto ${desktop ? "mt8 mb4" : "mb4"}`}
    >
      <UserAvatar size="lg" user={TalentpairUser} />
      <Box variant="column" layout="center-start" space={1}>
        <Typography variant="h1">Talentpair</Typography>
        <Box variant="row" layout="start-start" space={1}>
          <Typography variant="h2" color="grey.600">
            Assistant
          </Typography>
          <Badge text="BETA" bgColor="bg-blue-400" />
        </Box>
      </Box>
      <Box variant="column" layout="center-start" space={2} className="px3">
        <Typography variant="h2">Find tech talent!</Typography>
        <Typography variant="body1" align="center">
          Start by entering the job title or position you&apos;re looking to fill. Providing
          additional details such as skills or a location will help narrow down the best matches.
        </Typography>
      </Box>
      <Box variant="column" layout="center-start" space={3} className="px3">
        <Typography variant="h2">Examples</Typography>
        <PlaceholderBox
          text="I'm looking for Machine Learning Engineers in Boston, skilled at Python."
          onSubmit={onSubmit}
          data-testid="quick-search-1-btn"
        />
        <PlaceholderBox
          text="Hiring a Remote Senior Product Manger. Experience in B2B a must."
          onSubmit={onSubmit}
          data-testid="quick-search-2-btn"
        />
        <PlaceholderBox
          text="We need a VP of Engineering. New York Area, Hybrid. $450k max."
          onSubmit={onSubmit}
          data-testid="quick-search-3-btn"
        />
      </Box>
    </Box>
  );
}
